import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 20000
})

service.interceptors.request.use(config => {
  if (store.state.token) {
    config.headers.Authorization = `Bearer ${store.state.token}`
  }
  return config
})

service.interceptors.response.use(response => {
  if (response.config.responseType === 'blob') {
    return response
  }
  const body = response.data
  if (body && body.success === false) {
    Message.error(body.message || '请求失败')
    if (body.code === 401) {
      store.commit('CLEAR_LOGIN')
      router.replace('/login')
    }
    return Promise.reject(new Error(body.message || '请求失败'))
  }
  return body ? body.data : body
}, error => {
  const status = error.response && error.response.status
  if (status === 401) {
    store.commit('CLEAR_LOGIN')
    router.replace('/login')
    Message.error('登录已失效，请重新登录')
  } else {
    Message.error((error.response && error.response.data && error.response.data.message) || error.message || '网络异常')
  }
  return Promise.reject(error)
})

export default service
